import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { LoadingFullScreen } from '/imports/ui/LoadingFullScreen';
import { handleSmaAccessTokenCode } from '/imports/api/smaMeters';
import { strings } from '/imports/strings';

const SmaRedirectPageStyled = styled.div`
`;

/** OAuth landing page that exchanges the SMA authorization code for an access token. */
export const SmaRedirectPage = () => {
  const [loading, setLoading] = useState(true);
  const params = new URLSearchParams(location.search);
  const code = params.get('code');
  const state = JSON.parse(window.atob(params.get('state') || ''));
  const error = params.get('error');
  const { orgId, username } = state;
  useEffect(() => {
    if (code && orgId) {
      (async () => {
        await handleSmaAccessTokenCode.call({ code, orgId, username });
        setLoading(false);
      })();
    }
    else if (error) {
      console.log(error);
      toast.error(`${error}`);
    }
  }, []);
  if (loading) {
    return (
      <SmaRedirectPageStyled className="page">
        <LoadingFullScreen />
      </SmaRedirectPageStyled>
    );
  }
  return (
    <SmaRedirectPageStyled className="page">
      {strings.ThankYouForConnectingYourAccountToLuminia()}
    </SmaRedirectPageStyled>
  );
};
